'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/monthsFromNow.js
// module id = 342
// module chunks = 0